import { render, staticRenderFns } from "./cart-item.vue?vue&type=template&id=560f62f1&scoped=true&"
import script from "./cart-item.vue?vue&type=script&lang=js&"
export * from "./cart-item.vue?vue&type=script&lang=js&"
import style0 from "./cart-item.vue?vue&type=style&index=0&id=560f62f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f62f1",
  null
  
)

export default component.exports